(() => {
  const id = 'GTM-WZCPDDJ3';
  let loaded = false;
  window.dataLayer = window.dataLayer || [];
  const command = function () { window.dataLayer.push(arguments); };
  command('consent', 'default', {ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied', analytics_storage:'denied'});
  const update = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const marketing = privacy.marketingAllowed();
    const analytics = privacy.analyticsProcessingAllowed();
    const sharing = privacy.saleOfDataAllowed();
    command('consent', 'update', {
      ad_storage:marketing ? 'granted' : 'denied',
      ad_user_data:marketing && sharing ? 'granted' : 'denied',
      ad_personalization:marketing && sharing ? 'granted' : 'denied',
      analytics_storage:analytics ? 'granted' : 'denied'
    });
    if (!marketing || loaded) return;
    loaded = true;
    if ([...document.scripts].some(script => script.src.includes('/gtm.js?id=' + id))) return;
    window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
    document.head.append(script);
  };
  document.addEventListener('visitorConsentCollected', update);
  const init = () => {
    if (window.Shopify?.customerPrivacy) update();
    else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) update();});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
